// extracted by mini-css-extract-plugin
module.exports = {"link":"_28QZe","image":"g0Gi6","root":"_2UWWS"};